import React from "react";

import logo_svg from "../../common/icons/svg/logo.svg";
import print_svg from "../../common/icons/svg/print.svg";
import volume_svg from "../../common/icons/svg/volume.svg";
import CustomSelect from "../CustomSelect/CustomSelect";
import "./Header.scss";

export function Header(props) {

    return (

        <div className="header">
            <div className="logo-container">
                <div className="logo">
                    <img src={logo_svg} alt="logo svg" onClick={() => console.log("logo clicked !! ")} />
                </div>
                <div className="dashboard-text">HorizonView</div>
            </div>
            <div className="ward-container">
                <div className="hospital-name-container">
                    {props.hospitalName}
                </div>
                {/* <div className="print-icon-container">
                    <img src={print_svg} alt="print svg" onClick={() => console.log("print clicked !! ")} />
                </div> */}
                {/* <div className="volume-icon-container"> */}
                {/* <svg height="20" width="20" viewBox="0 0 20 20" className="svg">{volume_svg}</svg> */}
                {/* <img src={volume_svg} alt="volume svg" onClick={() => console.log("print clicked !! ")} /> */}
                {/* </div> */}
                <div className="select-container">
                    <CustomSelect
                        id="ward-name"
                        value={props.selectedWard}
                        handleChange={(item) => props.handleWardChange(item)}
                        label='label'
                        isClearable={false}
                        options={props.wardOption}
                        placeholder='Select Ward'
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        backgroundColor='#1F1F1F'
                    />
                </div>
            </div>
        </div>
    );
}